import Vue from 'vue';
import VueMoment from 'vue-moment';
import { currency } from '@/config/currency';

export default {
    init() {
        Vue.filter('currency', currency);
        Vue.use(VueMoment);
    },
};
